define(function (require, exports, module) {
    'use strict';

    var UploadError = require('./UploadError');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     */
    function FileTooLargeError(stack, source) {
        UploadError.apply(this, arguments);
    }

    FileTooLargeError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: FileTooLargeError,
        className: 'FileTooLargeError',
        radarName: 'error_{SOURCE}_file-too-large',
        message: 'Слишком большой файл.',
    });

    module.exports = FileTooLargeError;
});
